import React, { Component } from "react";
import $ from "jquery";
import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

import Loader from "../loader";
import UserImage from "../user_image";

import {
  userQuestions,
  userAnswers,
  userRecommendations,
  userHashtags
} from "../../helper/user_helper";

import FollowButton from "./follow_button";
import UserInfoRow from "./user_info_row";
import { renderErrorMessage } from "../../helper/user_helper";

import { Link } from "react-router-dom";
import UserHastags from "./user_data/user_hashtags";
// import UserDataSelection from "./user_data/user_data_selection";
import UserRecommendations from "./user_data/user_recommendations";

import { ShowingType } from "../../helper/type_helper";
import UserQuestionAnswer from "./user_data/user_question_answer";
import ProfileMenu from "./profile_menu";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

let strings = new LocalizedStrings({ en });

class UserProfile extends Component {
  state = {
    show: ShowingType.questions,
    answers: [],
    answers_page: 1,
    total_pages_answers: 0,
    questions: [],
    questions_page: 1,
    total_pages_questions: 0,
    hashtags: [],
    hashtags_selected: [],
    hashtags_page: 1,
    total_pages_hashtags: 0,
    recommendations: [],
    recommendations_page: 1,
    total_pages_recommendations: 0,
    can_load_more: true
  };

  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    // this.getUserQuestions(this.state.questions_page);
    this.getUserAnswers(this.state.answers_page);
    // this.getUserRecommendations(this.state.recommendations_page);
    // this.getUserHashtags(this.state.hashtags_page);
    this.refContainer.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    if (this.userQuestionsCall) {
      this.userQuestionsCall.cancel();
    }
    if (this.userAnswersCall) {
      this.userAnswersCall.cancel();
    }
    if (this.userRecommendationsCall) {
      this.userRecommendationsCall.cancel();
    }
    if (this.userHashtagsCall) {
      this.userHashtagsCall.cancel();
    }
    this.refContainer.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    if (this.state.can_load_more === false) {
      // Checking if we are not already loading more data
      return;
    }
    if (
      this.state.show === ShowingType.categories &&
      this.state.recommendations_page >= this.state.total_pages_recommendations
    ) {
      // We don't check anything if recommendations doesn't have other recommendations and we are on recommendations pages
      return;
    }
    if (
      this.state.show === ShowingType.recommendations &&
      this.state.questions_page >= this.state.total_pages_questions
    ) {
      // We don't check anything if questions doesn't have other questions and we are on questions pages
      return;
    }
    if (
      this.state.show === ShowingType.questions &&
      this.state.answers_page >= this.state.total_pages_answers
    ) {
      // We don't check anything if answers doesn't have other answers and we are on answers pages
      return;
    }
    if (
      $("#profile").scrollTop() + $("#profile").innerHeight() >=
      $("#profile")[0].scrollHeight
    ) {
      // Load More questions
      this.setState({ can_load_more: false });
      switch (this.state.show) {
        case ShowingType.recommendations: {
          const recommendations_page = this.state.recommendations_page + 1;
          this.setState({ recommendations_page });
          this.getUserRecommendations(recommendations_page);
          break;
        }
        case ShowingType.categories: {
          const hashtags_page = this.state.hashtags_page + 1;
          this.setState({ hashtags_page });
          this.getUserHashtags(hashtags_page);
          break;
        }
        case ShowingType.questions: {
          const answers_page = this.state.answers_page + 1;
          this.setState({ answers_page });
          this.getUserAnswers(answers_page);
          break;
        }
        default: {
        }
      }
    } else {
      // Nothing
    }
  }
  render() {
    var className = "profilePage center";
    if (this.props.me === true) {
    } else {
      className += " page_top_nav";
    }

    return (
      <React.Fragment>
        <div
          id="profile"
          ref={ref => {
            this.refContainer = ref;
          }}
          className={className}
        >
          {this.renderPage()}
        </div>
        {this.renderLogout()}
      </React.Fragment>
    );
  }

  renderPage() {
    if (this.props.loaded === false) {
      return <Loader loaded={this.props.loaded} />;
    }

    if (this.props.user === null) {
      // Return div if the user does not exist
      return (
        <div className="center">{renderErrorMessage(this.props.errors)}</div>
      );
    }

    return (
      <React.Fragment>
        {this.renderProfileImageOrDefault()}
        {renderErrorMessage(this.state.errors)}
        <label className="name">
          {this.props.user.first_name} {this.props.user.last_name}
        </label>
        <label className="username">{this.props.user.username}</label>

        <UserInfoRow user={this.props.user} />
        {/* {this.renderQuestionOfTheDay()} */}
        {/* <UserDataSelection
          show={this.state.show}
          handleChangeToRecommendation={this.handleChangeToRecommendation}
          handleChangeToCategory={this.handleChangeToCategory}
          handleChangeToQuestion={this.handleChangeToQuestion}
        /> */}
        {this.renderSelection()}
      </React.Fragment>
    );
  }
  renderQuestionOfTheDay() {
    if (this.props.me === true) {
      return (
        <Link to="/question">
          <button className="btn btn_primary btn_yaystack">
            {strings.questions_of_the_day}
          </button>
        </Link>
      );
    }
    return <div />;
  }
  renderLogout() {
    if (this.props.me === true) {
      return (
        <React.Fragment>
          <div className="edit_logout">
            <button
              className="btn btn_primary yaystack_primary_color right"
              onClick={this.props.handlerOpenMenu}
            >
              <FontAwesomeIcon className="yaystack_icon_navBar" icon={faBars} />
            </button>
            <Link to="/search">
              <button className="btn btn_primary yaystack_primary_color left">
                <ion-icon
                  class="yaystack_icon_navBar ion-icon"
                  name="ios-search"
                  style={{ fontSize: "28px" }}
                />
              </button>
            </Link>
          </div>
          <ProfileMenu
            handlerEdit={this.props.handlerEdit}
            handlerLogout={this.props.handlerLogout}
            handlerOpenMenu={this.props.handlerOpenMenu}
            handlerUpdatePassword={this.props.handlerUpdatePassword}
            handlerInviteFriend={this.props.handlerInviteFriend}
            handlerYayScore={this.props.handlerYayScore}
            handlerGoToBookmarks={this.props.handlerGoToBookmarks}
            handlerYaystackText={this.props.handlerYaystackText}
            openMenu={this.props.openMenu}
          />
        </React.Fragment>
      );
    }
    if (this.props.user === null) {
      return <div />;
    }
    return (
      <FollowButton
        user={this.props.user}
        handleAddFriend={this.props.handleAddFriend}
        handleRemoveFriend={this.props.handleRemoveFriend}
      />
    );
  }

  renderProfileImageOrDefault() {
    return (
      <div className="image-profile center mt-4">
        <UserImage user={this.props.user} />
      </div>
    );
  }

  renderSelection() {
    switch (this.state.show) {
      case ShowingType.recommendations: {
        return (
          <UserRecommendations
            recommendations={this.state.recommendations}
            username={this.props.username}
          />
        );
      }
      case ShowingType.categories: {
        return (
          <UserHastags
            hashtags={this.state.hashtags}
            hashtags_selected={this.state.hashtags_selected}
            username={this.props.username}
            me={this.props.me}
          />
        );
      }
      case ShowingType.questions: {
        const self = this;
        var answers = this.state.answers.map(function(answer) {
          return (
            <UserQuestionAnswer
              key={answer.id}
              answer={answer}
              updateAnswer={self.updateAnswer}
            />
          );
        });
        return (
          <div id="" className="center list_questions list center margin-top-1">
            <div className="max_width_500">{answers}</div>
          </div>
        );
      }
      default: {
        return <div />;
      }
    }
  }

  handleChangeToRecommendation = e => {
    const show = ShowingType.recommendations;
    this.setState({ show });
  };

  handleChangeToCategory = e => {
    const show = ShowingType.categories;
    this.setState({ show });
  };

  handleChangeToQuestion = e => {
    const show = ShowingType.questions;
    this.setState({ show });
  };

  getUserQuestions(page) {
    const self = this;
    this.userQuestionsCall = userQuestions(this.props.username, page);
    this.userQuestionsCall.promise
      .then(res => {
        const questions = self.state.questions.concat(res.questions);
        const total_pages = res.total_pages;
        self.setState({
          questions: questions,
          loaded: true,
          total_pages_questions: total_pages,
          errors: ""
        });
      })
      .catch(error => {
        self.setState({ errors: error.errors });
      });
  }

  getUserAnswers(page) {
    const self = this;
    this.userAnswersCall = userAnswers(this.props.username, page);
    this.userAnswersCall.promise
      .then(res => {
        const answers = self.state.answers.concat(res.answers);
        const total_pages = res.total_pages;
        self.setState({
          answers: answers,
          loaded: true,
          total_pages_answers: total_pages,
          errors: ""
        });
      })
      .catch(error => {
        self.setState({ errors: error.errors });
      });
  }

  getUserRecommendations(page) {
    const self = this;
    this.userRecommendationsCall = userRecommendations(
      this.props.username,
      page
    );
    this.userRecommendationsCall.promise
      .then(res => {
        const recommendations = self.state.recommendations.concat(
          res.recommendations
        );
        const total_pages = res.total_pages;
        self.setState({
          recommendations: recommendations,
          loaded: true,
          total_pages_recommendations: total_pages,
          errors: ""
        });
      })
      .catch(error => {
        self.setState({ errors: error.errors });
      });
  }

  getUserHashtags(page) {
    const self = this;
    this.userHashtagsCall = userHashtags(this.props.username, page);
    this.userHashtagsCall.promise
      .then(res => {
        if (page === 1) {
          const hashtags_selected = res.hashtags_selected;
          self.setState({ hashtags_selected: hashtags_selected });
        }
        const hashtags = self.state.hashtags.concat(res.hashtags);
        const total_pages = res.total_pages;
        self.setState({
          hashtags: hashtags,
          loaded: true,
          total_pages_hashtags: total_pages,
          errors: ""
        });
      })
      .catch(error => {
        self.setState({ errors: error.errors });
      });
  }

  updateAnswer = answer => {
    var answers = [...this.state.answers];
    for (var answer_id in answers) {
      if (answers[answer_id].id === answer.id) {
        const question = answers[answer_id].question;
        answers[answer_id] = answer;
        answers[answer_id].question = question;
        break;
      }
    }
    this.setState({ answers });
  };
}

export default UserProfile;



// WEBPACK FOOTER //
// ./src/components/profile/user_profile.jsx